import { updateInboundSelectedChangeDateAction } from "../../../Actions/LogicActions/ChangeDate/UpdateInboundSelectedChangeDateAction";
import { updateSelectedChangeDateAction } from "../../../Actions/LogicActions/ChangeDate/UpdateSelectedChangeDateAction";
import { updateSelectedRangeAction } from "../../../Actions/LogicActions/ChangeDate/UpdateSelectedRangeAction";
import { getPassengerDetailsAction } from "../../../Actions/LogicActions/Checkout/PassengerDetails/GetPassengerDetailsAction";
import { backToBookingClickAction } from "../../../Actions/UIActions/ChangeDate/BackToBookingClickAction";
import { changeDateContinueClickAction } from "../../../Actions/UIActions/ChangeDate/ChangeDateContinueClickAction";
import { changeDateRedirectClickAction } from "../../../Actions/UIActions/ChangeDate/ChangeDateRedirectClickAction";
import { mainInboundCheckAction } from "../../../Actions/UIActions/ChangeDate/MainInboundCheckAction";
import { mainOutBoundCheckAction } from "../../../Actions/UIActions/ChangeDate/MainOutBoundCheckAction";
import { passengerOutboundCheckAction } from "../../../Actions/UIActions/ChangeDate/PassengerOutboundCheckAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { changeDateTree } from "../../../Orchestrator/ConstantTree/ChangeDatePage/ChangeDateTree";
import { BackToBookingClickType } from "../../../Orchestrator/Types/Index";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { ChangeDateContext } from "../Context/ChangeDateContext";

export class ChangeDateInitStep extends StepFlow {
    get stepName() { return "ChangeDateInit_Step"; }

    async onEventSetup(): Promise<void> {

        this.registerEventSubscription(
            _eventBus.on({
                eventName: changeDateTree.ChangeDate.Init,
                handler: async () => {
                    let context = this.getCtx<ChangeDateContext>("changeDateContext")!;
                    // await getUserDetailsAction.execute();/
                    await getPassengerDetailsAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: changeDateTree.ChangeDate.PassengerOutboundCheck,
                handler: async (data: any) => {
                    passengerOutboundCheckAction.setParams(data.data!);
                    await passengerOutboundCheckAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: changeDateTree.ChangeDate.MainOutboundCheck,
                handler: async (data: any) => {
                    mainOutBoundCheckAction.setParams(data.data!);
                    await mainOutBoundCheckAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: changeDateTree.ChangeDate.MainInboundCheck,
                handler: async (data: any) => {
                    mainInboundCheckAction.setParams(data.data!);
                    await mainInboundCheckAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            // _eventBus.on({
            _eventBus.on<BackToBookingClickType, void>({
                eventName: changeDateTree.ChangeDate.BackToBookingClick,
                handler: async ({ data }) => {
                    if (data?.flow === "ChangeDateFlow") {
                        /**
                         * If your flow start by orchestrator then,
                         * you have to tell to orchestrator to close the flow if,
                         * you want to close the flow on some action.
                         * */
                        _eventBus.emit({
                            eventName: "FLOW_CLOSE",
                            data: "ChangeDateFlow"
                        })

                        let context = this.getCtx<ChangeDateContext>("changeDateContext");
                        const routeToNavigate = context?.previousRoute || "/bookings";

                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: routeToNavigate,
                        });
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: changeDateTree.ChangeDate.ChangeDateContinueClick,
                handler: async (data: any) => {
                    //let context = this.getCtx<ChangeDateContext>("changeDateContext")!;
                    changeDateContinueClickAction.setParams(data.data!);
                    await changeDateContinueClickAction.execute();
                    if (isActionRunSuccessfully(changeDateContinueClickAction)) {
                        const result: IDefaultActionResult = changeDateContinueClickAction.result!;
                        if (result.status == "success") {                            
                            this.next();
                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: data.data.redirectPath,
                            })

                        }
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: changeDateTree.ChangeDate.UpdateSelectedRange,
                handler: async (data: any) => {
                    updateSelectedRangeAction.setParams(data.data!);
                    await updateSelectedRangeAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: changeDateTree.ChangeDate.UpdateSelectedChangeDate,
                handler: async (data: any) => {
                    updateSelectedChangeDateAction.setParams(data.data!);
                    await updateSelectedChangeDateAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: changeDateTree.ChangeDate.UpdateInboundSelectedChangeDate,
                handler: async (data: any) => {
                    updateInboundSelectedChangeDateAction.setParams(data.data!);
                    await updateInboundSelectedChangeDateAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: changeDateTree.ChangeDate.ChangeDateRedirectClick,
                handler: async (data: any) => {                    
                    let context = this.getCtx<ChangeDateContext>("changeDateContext")!;
                    
                    if (typeof window !== "undefined" && window?.location) {
                        context.previousRoute = window?.location?.pathname + (window?.location?.search || "");
                    }

                    changeDateRedirectClickAction.setParams(data.data!);
                    await changeDateRedirectClickAction.execute();
                    if (changeDateRedirectClickAction.status.executionStatus == ExecutionStatus.SUCCESS) {
                        context.allFulFillOutBoundPassIds = changeDateRedirectClickAction.result?.allFulFillOutBoundPassIds ?? [];
                        context.outBoundPassengerPriceList = changeDateRedirectClickAction.result?.outBoundPassengerPriceList ?? [];
                        context.bookingResponse = changeDateRedirectClickAction.result?.bookingResponse ?? null;

                        _eventBus.emit({
                            eventName: "ROUTE_CHANGE",
                            data: data.data.route,
                        })
                    }
                }
            })
        )

    }

    async onExecute(): Promise<void> {
        this.setCtx("changeDateContext", ChangeDateContext);
        console.log("Change Date Initialize.....")
    }

}

export const ChangeDateInitStepDeclaration = new StepDefinition({
    stepName: "ChangeDateInit_Step",
    stepClass: ChangeDateInitStep
});